var $32a515ef673b0655$exports = {};
$32a515ef673b0655$exports = {
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Izberite element`,
    "tableResizer": `Spreminjanje velikosti`,
    "colorSwatchPicker": `Color swatches`
};


export {$32a515ef673b0655$exports as default};
//# sourceMappingURL=sl-SI.mjs.map
